import { render, staticRenderFns } from "./DfLabel.vue?vue&type=template&id=606e3a2f&scoped=true&"
import script from "./DfLabel.vue?vue&type=script&lang=js&"
export * from "./DfLabel.vue?vue&type=script&lang=js&"
import style0 from "./DfLabel.vue?vue&type=style&index=0&id=606e3a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606e3a2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606e3a2f')) {
      api.createRecord('606e3a2f', component.options)
    } else {
      api.reload('606e3a2f', component.options)
    }
    module.hot.accept("./DfLabel.vue?vue&type=template&id=606e3a2f&scoped=true&", function () {
      api.rerender('606e3a2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-dynamic-fieldset/fields/DfLabel.vue"
export default component.exports